import React from 'react';
import { BarChart3 } from 'lucide-react';

export default function InventoryTurnoverChart({ data }) {
  if (!data || data?.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <BarChart3 className="w-5 h-5 text-green-600" />
          Rotation Inventaire
        </h2>
        <p className="text-gray-500 text-center py-8">Aucune donnée disponible</p>
      </div>
    );
  }

  const maxValue = Math.max(...data?.map(d => Math.max(d?.noir_270l || 0, d?.bleu_220l || 0)));

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
        <BarChart3 className="w-5 h-5 text-green-600" />
        Rotation Inventaire
      </h2>
      
      <div className="space-y-4">
        {data?.map((item, index) => (
          <div key={index}>
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-700">{item?.month}</span>
              <div className="flex items-center gap-4 text-xs text-gray-600">
                <span className="flex items-center gap-1">
                  <div className="w-3 h-3 bg-gray-800 rounded"></div>
                  Noir: {item?.noir_270l}
                </span>
                <span className="flex items-center gap-1">
                  <div className="w-3 h-3 bg-blue-500 rounded"></div>
                  Bleu: {item?.bleu_220l}
                </span>
              </div>
            </div>
            
            <div className="flex gap-1 h-8">
              <div
                className="bg-gray-800 rounded transition-all duration-300 hover:bg-gray-700"
                style={{ width: `${(item?.noir_270l / maxValue) * 100}%` }}
                title={`Noir 270L: ${item?.noir_270l} unités`}
              ></div>
              <div
                className="bg-blue-500 rounded transition-all duration-300 hover:bg-blue-600"
                style={{ width: `${(item?.bleu_220l / maxValue) * 100}%` }}
                title={`Bleu 220L: ${item?.bleu_220l} unités`}
              ></div>
            </div>
            
            <div className="flex items-center justify-between mt-1 text-xs text-gray-500">
              <span>{item?.orders} commandes</span>
              <span>€{item?.revenue?.toFixed(2)}</span>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-6 pt-4 border-t border-gray-200">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Total commandes</span>
          <span className="font-semibold text-gray-900">
            {data?.reduce((sum, d) => sum + (d?.orders || 0), 0)}
          </span>
        </div>
        <div className="flex items-center justify-between text-sm mt-2">
          <span className="text-gray-600">Revenu total</span>
          <span className="font-semibold text-green-600">
            €{data?.reduce((sum, d) => sum + (d?.revenue || 0), 0)?.toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
}